import { useEffect, useState } from 'react';

import { getStripeFeature } from '@/pages/AccountSettings/api';

/**
 * Account-level feature flag that gates visibility of PMS providers marked
 * `beta: true` in the PMS_PROVIDERS registry. Off by default; Support flips
 * it on per-account via the batch-update-features endpoint.
 */
export function usePmsBetaEnabled() {
  const [pmsBetaEnabled, setPmsBetaEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const feat = (await getStripeFeature()) ?? { features: [] };
        setPmsBetaEnabled(feat.features.includes('PMS_BETA'));
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return { pmsBetaEnabled, loading };
}
